import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { FlowsheetConstants } from "@/Flowsheets/FlowsheetConstants";
import { BooleanReviewedCareElement } from "@/Flowsheets/Models/CareElements/BooleanReviewedCareElement";
import { CareComponent } from "@/Flowsheets/Models/CareElements/CareComponent";
import { CareElementType } from "@/Flowsheets/Models/CareElements/CareElementType";
import { SubjectCareElement } from "@/Flowsheets/Models/CareElements/SubjectCareElement";
import CareElementDateReviewedCheckbox from "./CareComponentParts/DateReviewedCareElementComponents/CareElementDateReviewedCheckbox";
import { CareElementSubjectDateReviewedControl } from "./CareComponentParts/DateReviewedCareElementComponents/CareElementSubjectDateReviewed";
import { ICareComponentProps } from "./Types";

import styles from "./ScreeningCareComponent.module.scss";

interface SubjectCareComponent extends CareComponent {
    CareElements: (SubjectCareElement | BooleanReviewedCareElement)[];
}

function ScreeningCareComponent({ isEditable = false, state, mutateState }: Readonly<ICareComponentProps<SubjectCareComponent>>): JSX.Element {
    const { getText } = useTranslation();

    function handleChange(element: SubjectCareElement | BooleanReviewedCareElement): void {
        mutateState(state => {
            state.CareElements = [...state.CareElements];
            const index = state.CareElements.findIndex(p => p.Name === element.Name);
            if (index !== -1) {
                state.CareElements[index] = element;
            }
        });
    }

    const getLabel = (SubjectCareElement: SubjectCareElement | BooleanReviewedCareElement): string => getText(`Flowsheets_ScreeningCareComponentLabel_${SubjectCareElement.Name}`);

    return (
        <div>
            {/* Header Row */}
            <div className={styles.subsectionTitleLabel}>{getText("ExamLabel")}</div>

            {/* Data Rows */}
            <div className={styles.screeningColumn}>
                {state.CareElements.map(p => {
                    if (p.CareElementType === CareElementType.BooleanReviewed) {
                        return (
                            <div
                                className={styles.screeningGrid}
                                key={`${p.Name}-${state.Id}`}
                            >
                                <CareElementDateReviewedCheckbox
                                    label={getLabel(p)}
                                    isEditable={isEditable}
                                    element={p}
                                    onChange={handleChange}
                                />
                            </div>
                        );
                    }
                    else if (p.CareElementType === CareElementType.Subject) {
                        const getSubLabel = (SubjectCareElement: SubjectCareElement): string => getText(`Flowsheets_ScreeningCareComponentLabel_${SubjectCareElement.Name}Sublabel`);

                        const label = (p.Name === FlowsheetConstants.Screening.NeurologicalCareElementName)
                            ? (<div>{getLabel(p)}<br />{getSubLabel(p)}</div>)
                            : getLabel(p);

                        return (
                            <div
                                className={styles.screeningGrid}
                                key={`${p.Name}-${state.Id}`}
                            >
                                <CareElementSubjectDateReviewedControl
                                    label={label}
                                    isEditable={isEditable}
                                    element={p}
                                    onChange={handleChange}
                                />
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}

export { ScreeningCareComponent };
